// extracted by mini-css-extract-plugin
module.exports = {"proTip":"F0jvp7eY9ZN2_9B4LbH5F"};